import { useEffect, useState } from 'react';

import { ApplicationEventNames } from '~/constants/ApplicationEvents';
import { RequireAuthentication } from '~/helpers/RequireAuthentication';
import { DepositTransferModalKey, UrlModalHelper } from '~/helpers/UrlModalHelper';
import { Modal } from '~/vinovest-design-system/components';

import { ConfirmAcknowledgements } from './ConfirmAcknowledgements';
import { ConnectSourceModalContent } from './ConnectSourceModalContent';
import { DepositInitiated } from './DepositInitiated';
import { ReviewTransfer } from './ReviewTransfer';
import { TransferFunds } from './TransferFunds';
import { observer } from 'mobx-react-lite';

export const DepositTransferModal = observer(() => {
    const [step, setStep] = useState(0);
    const [plaidComplete, setIsPlaidComplete] = useState(true);
    const open = UrlModalHelper.isModalOpen(DepositTransferModalKey);

    let component;
    let title = '';

    switch (step) {
        case 0:
            component = <TransferFunds setStep={setStep} />;
            title = 'Transfer Funds';
            break;
        case 1:
            component = <ReviewTransfer setStep={setStep} />;
            title = 'Review Transfer';
            break;
        case 2:
            component = <DepositInitiated />;
            title = 'Deposit Initiated';
            break;
        case 3:
            component = (
                <ConnectSourceModalContent setIsPlaidComplete={setIsPlaidComplete} onPaymentAdded={() => setStep(0)} />
            );
            title = '';
            break;
        case 4:
            component = <ConfirmAcknowledgements setStep={setStep} />;
            title = 'Transfer Funds';
            break;
        default:
            component = <TransferFunds setStep={setStep} />;
            title = 'Transfer Funds';
    }

    useEffect(() => {
        setStep(0);
    }, [open]);

    const setNewOpenHandler = () => {
        if (!plaidComplete) {
            return;
        }

        window.dispatchEvent(new CustomEvent(ApplicationEventNames.DepositModalClosed));
        UrlModalHelper.close(DepositTransferModalKey);
    };

    return (
        <RequireAuthentication>
            <Modal
                classnames={'max-w-[338px] w-11/12 z-[100]'}
                open={open}
                setOpen={setNewOpenHandler}
                modalKey={DepositTransferModalKey}
            >
                <h2 className={'text-20 font-roslindale md:mt-0 mb-6'}>{title}</h2>
                {component}
            </Modal>
        </RequireAuthentication>
    );
});

export default DepositTransferModal;
